import React from 'react'
import FAQ from '../../ui_components/faq_component/FAQ'
import DownloadAppUI from '../../ui_components/download_app/download_app'
import SiteFooter from '../../ui_components/site_footer/site_footer'
import './about_us.css'

export default function Aboutus() {
  return (
    <div className='container'>
      <>
        <div className="about-container">
          <h1>About Us – Wedstra</h1>
          <h2>Wedstra – India’s Complete Wedding Planning Marketplace</h2>

          <p>
            At Wedstra, we understand that weddings in India are more than just ceremonies –
            they are once-in-a-lifetime celebrations of love, tradition, and family.
            But planning such a grand event can often feel stressful and time-consuming.
            That’s why we built Wedstra – a modern wedding planning platform in India
            that connects couples with everything they need to plan their perfect wedding.
          </p>

          <p>
            Whether you are searching for the best wedding vendors in India, exploring destination wedding venues,
            or looking for the top wedding photographers, bridal makeup artists, decorators, planners, or caterers –
            Wedstra brings it all together in one trusted place.
          </p>

          <h3>Our Mission</h3>
          <p>
            To make wedding planning simple, stress-free, and transparent by helping couples discover trusted vendors,
            compare prices, and find inspiration – all in just a few clicks.
          </p>

          <h3>Why Choose Wedstra?</h3>
          <ul className="about-features">
            <li>✨ Discover Top Wedding Vendors – Explore thousands of verified wedding vendors across India including planners, photographers, makeup artists, decorators, venues, and more.</li>
            <li>✨ Plan Destination Weddings with Ease – From palaces in Rajasthan and beaches in Goa to luxury resorts and budget-friendly venues, Wedstra helps couples find their dream wedding destination.</li>
            <li>✨ Compare Prices & Reviews – Make informed choices with transparent pricing, real portfolios, and genuine reviews from couples who’ve been there before.</li>
            <li>✨ Wedding Inspiration & Trends – Browse real wedding stories, décor themes, fashion trends, and expert blogs to design your big day.</li>
            <li>✨ Smart Wedding Tools – Use checklists, budget planners, and planning guides to stay on track at every step.</li>
          </ul>

          <h3>Trusted by Couples Across India</h3>
          <p>
            From intimate celebrations to grand royal weddings, Wedstra is India’s trusted wedding marketplace where couples can save time, reduce stress, and plan confidently.
            Thousands of brides and grooms already use Wedstra to turn their wedding dreams into reality – and now it’s your turn.
          </p>

          <p>
            Because at Wedstra, we don’t just help you plan a wedding.
            We help you create memories that last forever.
          </p>
        </div>
      </>
      <section className="my-5">
        {/* Site Footer */}
        <div>
          <SiteFooter />
        </div>
        {/* Download the app */}
        <div id='download-app-container' className='m-0'>
          <DownloadAppUI />
        </div>
        {/* FAQ */}
        <div>
          <FAQ />
        </div>
      </section>
    </div>
  )
}
